
import Iconone from '../Components/images/icons/address.png'

 import Icontwo from '../Components/images/icons/phone.png'
 import Iconthree from '../Components/images/icons/email.png'
 import Iconfour from '../Components/images/logo.png'
import { Link } from 'react-router-dom'
import { FaFacebookF, FaInstagram ,FaPinterest, FaWhatsapp} from 'react-icons/fa';
import{AiFillYoutube } from 'react-icons/ai';
import{GrLinkedinOption} from 'react-icons/gr'
import {api,footerurl} from './Costants'
import { useState,useEffect } from 'react'
function Footer() {     
    const [userst, setUsers] = useState([])
    const details_fetch = async () =>{
      const response = await fetch( api + 'company_profile_list', {
        method: "POST", 
        mode:'cors',
        headers: {
        'Accept':'aplication/json',
          "Content-Type": "application/json"
      }});
        const data = await response.json();   
        setUsers(data.records[0])
    }
     useEffect(() => {
    details_fetch();
  
  }, []) 
    return (
            <footer className="footer">

                 <a
      href={`https://wa.me/919894090587`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
    >
      <FaWhatsapp size={28} />
    </a>


                <div className="footer-top pt-30">
                    <div className="container">
                        <div className="footer-top-content">
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <div className="footer-top-inner text-center">
                                        <div className="icon-part text-center">
                                            <img src={Iconone} alt="image" />
                                        </div>
                                        <h3>ADDRESS</h3>
                                        <p><a  href="https://www.google.com/maps/place/Sri+Raghavendra+Decors/@11.08266,77.0305798,1031m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3ba859d676db5273:0x76f0fd7cd668167a!8m2!3d11.0826547!4d77.0331547!16s%2Fg%2F1q6nz9r4k?entry=ttu&g_ep=EgoyMDI1MTAwNC4wIKXMDSoASAFQAw%3D%3D"
                                        target="_blank">
                                            {/* {userst.address1}<br/>{userst.address2}-{userst.pincode} */}
                                            No.127, Chandra Garden, <br/> Kattor Street, Kalapatti, Coimbatore,<br/> Tamil Nadu 641048 
                                            
                                            </a></p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="footer-top-inner text-center">
                                            <div className="icon-part text-center">
                                                <img src={Icontwo} alt="image" />
                                            </div>
                                            <h3>CALL US</h3>
                                            {/* <a href={`tel:+91${userst.mobile}`} > <p className='footer-mob-b'>+91 {userst.mobile}</p></a> */}
                                            <a href={`tel:+91 9894090587`}> <p>+91 98940 90587 </p></a>
                                            <a href={`tel:+91 9597190587`}> <p>+91 95971 90587 </p></a>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="footer-top-inner text-center">
                                            <div className="icon-part text-center">
                                                <img src={Iconthree} alt="image" />
                                            </div>
                                            <h3>EMAIL US</h3>
                                            <a href={`mailto:${userst.email}`}> <p> {userst.email}</p></a>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    { /*<!-- footer top end -->
    <!-- footer row 1 start -->*/}
                    <div className="footer-row-1 position-relative pt-150 pb-25">
                        <div className="container">
                            <div className="footer-img text-center">
                                <Link to='/'><img src={Iconfour} alt="image" width="20%" /></Link>
                            </div>
                            <div className="footer-link mt-4">
                                <ul>
                                    <li> <Link  to="/"> Home</Link> </li>
                                    <li> <Link to="/about"> About Us</Link> </li>
                                    <li> <Link to="/theme"> Themes</Link> </li>
                                    <li> <Link to="/gallery"> Gallery</Link> </li>
                                    <li> <Link to="/privacy-policy"> Privacy policy</Link> </li>
                                    <li> <Link to="/contact"> Contact us</Link> </li>
                                </ul>
                            </div>
                            <div className="footer-social-link mt-5">
                                <ul>
                                    <li> <a href={userst.facebook}><FaFacebookF/></a> </li>
                                   <li> <a href={userst.instagram}><FaInstagram/></a> </li>
                                  <li> <a href={userst.linked_in}><GrLinkedinOption/></a> </li>
                                      <li> <a href={userst.youtube}><AiFillYoutube/></a> </li>
                                      <li> <a href={userst.twitter}> <FaPinterest/></a> </li>
                                       <li>
  <a 
    href="https://wa.me/919894090587" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <FaWhatsapp />
  </a>
</li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    
                    <div className="footer-row-2 pt-10 pb-10 ">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="footer-left">
                                        <p className="m-0">Copyright &#169; 2023 <Link to='/' className="font2"> {userst.company_name}</Link>. All Rights Reserved.</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                               

                                    <div className="footer-right text-lg-right text-md-right ">
                                        <p className="m-0">Designed by  <Link className='font2' to='https://banyaninfotech.com'>The Banyan Infotech</Link>.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                

            </footer>
    )
}

export default Footer
